export default class hr {
	static translations = {
		labels: {
			logout: "Logout",
			profile: "Profil",
			rowsPerPage: "Redaka po stranici:",
			all: "Svi",
			noResults: "Nema rezultata.",
			of: "od",
			selectItem: "Odaberite opciju",
			from: "od",
			to: "do",
			uploadInProgress: "Upload u tijeku.",
			passwordResetOk: "Nova lozinka poslana je na Vašu e-mail adresu.",
			passwordResetFail: "Ovaj link je istekao ili je iskorišten.",
			hr: "HR",
			dragdrop: "Povucite datoteke ovdje",
			dragdropSingle: "Povucite datoteku ovdje",
			yes: "Da",
			no: "Ne",
			passwordReset: "Unesite e-mail za promjenu lozinke.",
			opportunityId: "Opportunity ID",
			videoUrl: "Video URL",
			results: "Rezultati za nekretninu",
			category: "Kategorija",
			objectID: "Šifra objekta",
			county: "Županija",
			city: "Mjesto",
			location: "Naselje",
			noFilesUploaded: "Nema učitanih datoteka",
		},
		modules: {
			login: "Login",
			dashboard: "Dashboard",
			userAccounts: "Korisnički računi",
			profile: "Moj profil",
			newUserAccount: "Novi korisnički račun"
		},
		fields: {
			firstName: "Ime",
			lastName: "Prezime",
			email: "E-mail",
			password: "Lozinka",
			rememberMe: "Zapamti me",
			passwordChange: "Promjena lozinke",
			oldPassword: "Stara lozinka",
			newPassword: "Nova lozinka",
			newPasswordConfirmation: "Ponovljena nova lozinka",
			active: "Aktivan",
			role: "Uloga"
		},
		alerts: {
			removalQuestion: "Jeste li sigurni da želite ukloniti ovaj zapis?",
			fileDeletionQuestion: "Jeste li sigurni da želite izbrisati ovu datoteku??",
			emailMissing: "Niste upisali e-mail.",
			emailFailFormat: "E-mail nije u ispravnom formatu.",
			passwordMissing: "Niste upisali lozinku.",
			passwordFailConfirmation: "Lozinke se ne podudaraju.",
			passwordResetSuccess: "Nova lozinka je poslana na e-mail adresu.",
			passwordResetFail: "Nije pronađen korisnik s unesenom e-mail adresom.",
			basicUpdate: "Promjene spremljene.",
			basicDelete: "Zapis izbrisan.",
			basicAdd: "Zapis dodan.",
			basicError: "Došlo je do greške na poslužitelju.",
			fileSize: "Datoteka je prevelika. Maksimalna veličina datoteke je 15MB.",
			fileSizeMultiple: "Datoteka %filename% je prevelika. Maksimalna veličina datoteke je 15MB.",
			oldPasswordFail: "Stara lozinka nije ispravna.",
			passwordLength: "Lozinka mora imati minimalno 8 znakova.",
			loginFail: "Neispravni podaci.",
			logoutQuestion: "Jeste li sigurni da se želite odjaviti?",
			fieldError: "Ovo polje je obavezno.",
			leaveQuestion: "Jeste li sigurni da želite otići bez spremanja?",
			maxFiles: "Maksimalnih broj dokumenata koje možete uploadati je 15."
		},
		buttons: {
			login: "Prijava",
			logout: "Odjava",
			profile: "Moj profil",
			new: "Novo",
			save: "Spremi",
			saveAndClose: "Spremi i zatvori",
			add: "Dodaj",
			cancel: "Odustani",
			yes: "Da",
			no: "Ne",
			ok: "OK",
			all: "Svi",
			delete: "Briši",
			back: "Povratak",
			forgottenPassword: "Zaboravljena lozinka?",
			send: "Pošalji",
			addUserAccount: "Dodaj korisnički račun",
			search: "Pretraga",
		},
		tooltips: {
			logout: "Odjava",
			excel: "Excel izvoz",
			filter: "Filter",
			openInNewTab: "Otvori u novom tabu",
			delete: "Izbriši",
			uploadFile: "Dodaj datoteku",
			removeFile: "Izbriši datoteku",
			downloadAll: "Preuzmi sve datoteke"
		}
	}
}

